export const ROLES = {
    COORDINATOR: 'coordinator', // The admin of the tenant
    GUEST: 'guest',
    TRANSPORTER: 'transporter',
    GATE_STAFF: 'gate_staff',
    DOCK_STAFF: 'dock_staff',
    CONSULTANT: 'consultant' // System super-admin
};

export const PERMISSIONS = {
    // Feature Groups
    DASHBOARD: 'dashboard',
    TRANSPORTERS: 'transporters',
    VEHICLES: 'vehicles',
    PLANNING: 'planning',
    DOCKS: 'docks',
    RESERVATIONS: 'reservations', // Operational management & tracking
    MY_RESERVATIONS: 'my_reservations', // Transporter personal view
    GATE_PROCESS: 'gate_process',
    DOCK_PROCESS: 'dock_process',
    USER_MANAGEMENT: 'user_management',
    PERMISSION_MANAGEMENT: 'permission_management',
    SETTINGS: 'settings',
    DRIVERS: 'drivers',
    VIEW_CARRIER_PERFORMANCE: 'view_carrier_performance',

    // Action Types
    VIEW: 'view',
    CREATE: 'create',
    EDIT: 'edit',
    DELETE: 'delete',
    EXECUTE: 'execute'
};

export const DEFAULT_ROLE_PERMISSIONS = {
    [ROLES.COORDINATOR]: {
        [PERMISSIONS.DASHBOARD]: [PERMISSIONS.VIEW],
        [PERMISSIONS.TRANSPORTERS]: [PERMISSIONS.VIEW, PERMISSIONS.CREATE, PERMISSIONS.EDIT, PERMISSIONS.DELETE],
        [PERMISSIONS.VEHICLES]: [PERMISSIONS.VIEW, PERMISSIONS.CREATE, PERMISSIONS.EDIT, PERMISSIONS.DELETE],
        [PERMISSIONS.PLANNING]: [PERMISSIONS.VIEW, PERMISSIONS.CREATE, PERMISSIONS.EDIT, PERMISSIONS.DELETE],
        [PERMISSIONS.DOCKS]: [PERMISSIONS.VIEW, PERMISSIONS.CREATE, PERMISSIONS.EDIT, PERMISSIONS.DELETE],
        [PERMISSIONS.USER_MANAGEMENT]: [PERMISSIONS.VIEW, PERMISSIONS.CREATE, PERMISSIONS.EDIT, PERMISSIONS.DELETE],
        [PERMISSIONS.PERMISSION_MANAGEMENT]: [PERMISSIONS.VIEW, PERMISSIONS.CREATE, PERMISSIONS.EDIT, PERMISSIONS.DELETE],
        [PERMISSIONS.RESERVATIONS]: [PERMISSIONS.VIEW, PERMISSIONS.CREATE, PERMISSIONS.EDIT, PERMISSIONS.DELETE],
        [PERMISSIONS.GATE_PROCESS]: [PERMISSIONS.VIEW, PERMISSIONS.EXECUTE],
        [PERMISSIONS.DOCK_PROCESS]: [PERMISSIONS.VIEW, PERMISSIONS.EXECUTE],
        [PERMISSIONS.SETTINGS]: [PERMISSIONS.VIEW, PERMISSIONS.CREATE, PERMISSIONS.EDIT, PERMISSIONS.DELETE],
        [PERMISSIONS.DRIVERS]: [PERMISSIONS.VIEW, PERMISSIONS.CREATE, PERMISSIONS.EDIT, PERMISSIONS.DELETE],
        [PERMISSIONS.VIEW_CARRIER_PERFORMANCE]: [PERMISSIONS.VIEW]
    },
    [ROLES.TRANSPORTER]: {
        [PERMISSIONS.DASHBOARD]: [PERMISSIONS.VIEW],
        [PERMISSIONS.VEHICLES]: [PERMISSIONS.VIEW, PERMISSIONS.CREATE, PERMISSIONS.EDIT],
        [PERMISSIONS.DRIVERS]: [PERMISSIONS.VIEW, PERMISSIONS.CREATE, PERMISSIONS.EDIT],
        [PERMISSIONS.MY_RESERVATIONS]: [PERMISSIONS.VIEW, PERMISSIONS.CREATE]
    },
    [ROLES.GATE_STAFF]: {
        [PERMISSIONS.GATE_PROCESS]: [PERMISSIONS.VIEW, PERMISSIONS.EXECUTE],
        [PERMISSIONS.VEHICLES]: [PERMISSIONS.VIEW]
    },
    [ROLES.DOCK_STAFF]: {
        [PERMISSIONS.DOCK_PROCESS]: [PERMISSIONS.VIEW, PERMISSIONS.EXECUTE],
        [PERMISSIONS.DOCKS]: [PERMISSIONS.VIEW]
    }
};

export const DEFAULT_OWNER_ROLES = [ROLES.COORDINATOR];
export const DEFAULT_TRANSPORTER_ROLES = [ROLES.TRANSPORTER];

export const DEFAULT_NOTIFICATION_PREFERENCES = {
    [ROLES.COORDINATOR]: ['time_change', 'plate_change', 'driver_change', 'status_change', 'ramp_change', 'note_added'],
    [ROLES.TRANSPORTER]: ['time_change', 'status_change', 'ramp_change', 'note_added'],
    [ROLES.GATE_STAFF]: ['plate_change', 'status_change', 'note_added'],
    [ROLES.DOCK_STAFF]: ['time_change', 'status_change', 'ramp_change', 'note_added']
};

// Menu to Permission Mapping
export const MENU_PERMISSIONS = {
    '/': PERMISSIONS.DASHBOARD,
    '/coordinator/transporters': PERMISSIONS.TRANSPORTERS,
    '/coordinator/planning': PERMISSIONS.PLANNING,
    '/coordinator/reservation-management': PERMISSIONS.RESERVATIONS,
    '/coordinator/docks': PERMISSIONS.DOCKS,
    '/operations/tracking': PERMISSIONS.RESERVATIONS,
    '/analysis/carrier-performance': PERMISSIONS.VIEW_CARRIER_PERFORMANCE,
    '/transporter/vehicles': PERMISSIONS.VEHICLES,
    '/transporter/reservations': PERMISSIONS.MY_RESERVATIONS,
    '/gate/process': PERMISSIONS.GATE_PROCESS,
    '/dock/loading': PERMISSIONS.DOCK_PROCESS,
    '/admin/users': PERMISSIONS.USER_MANAGEMENT,
    '/admin/permissions': PERMISSIONS.PERMISSION_MANAGEMENT,
    '/admin/settings': PERMISSIONS.SETTINGS,
    '/transporter/drivers': PERMISSIONS.DRIVERS
};
